module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Family name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.familyName),
      expression: "familyName"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.familyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.familyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Given name(s)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.givenName),
      expression: "givenName"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.givenName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.givenName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Date of birth")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-2 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_d),
      expression: "dob_d"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "DD"
    },
    domProps: {
      "value": (_vm.dob_d)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_d = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_m),
      expression: "dob_m"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.dob_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_m = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column col-3 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_y),
      expression: "dob_y"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "YYYY"
    },
    domProps: {
      "value": (_vm.dob_y)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_y = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Passport Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.docNumber),
      expression: "docNumber"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.docNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.docNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Document country")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.docCountry),
      expression: "docCountry"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.docCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(v, k) {
    return _c('option', {
      domProps: {
        "value": v
      }
    }, [_vm._v(_vm._s(k))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-md-12"
  }, [(_vm.results && _vm.results.success) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-title h5"
  }, [_vm._v("Results")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.resultFields), function(desc, field) {
    return _c('div', {
      staticClass: "columns"
    }, [(_vm.results[field]) ? _c('div', {
      staticClass: "col-3 col-sm-12"
    }, [_vm._v(_vm._s(desc))]) : _vm._e(), _vm._v(" "), (_vm.results[field]) ? _c('div', {
      staticClass: "col-9 col-sm-12"
    }, [_vm._v(_vm._s(_vm.results[field]))]) : _vm._e()])
  }), _vm._v(" "), (_vm.results.conditions) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_vm._v("Visa conditions")]), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, _vm._l((_vm.results.conditions), function(c) {
    return _c('div', {
      domProps: {
        "innerHTML": _vm._s(c)
      }
    })
  }), 0)]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.message) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.results.message))]) : _vm._e(), _vm._v(" "), (_vm.errormsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errormsg))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-secondary text-center"
  }, [_c('p', [_vm._v("Visa Entitlement Verification Online - check visa details and conditions.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b35142"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vevo.vue
// module id = 496
// module chunks = 1